<template>
  <div>
    <v-autocomplete
      :label="$t('module.meta.keys.chart_default_aggregation')"
      :items="aggregationTypes"
      v-model="chartType"
      item-text="name"
      item-value="value"
      prepend-icon="mdi-chart-timeline-variant"
    />
  </div>
</template>

<script>
import { chartMixin } from "@/_helpers/chartMixin";
export default {
  name: "ChartTypeSelector",

  props: {
    value: {
      default: String,
      require: true,
    },
  },

  model: {
    prop: "value",
  },

  mixins: [chartMixin],

  data() {
    return {};
  },

  computed: {
    chartType: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
};
</script>
